import * as React from "react";
import { SVGProps } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={7}
    height={12}
    fill="none"
    {...props}
  >
    <path
      fill="#565963"
      d="m1.15 11.077-1.073-1.07 4.012-4.01L.084 1.994 1.154.923l5.077 5.073-5.081 5.08Z"
    />
  </svg>
);
export default SvgComponent;
